import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const EmptyState = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    className="relative bg-gray-50 rounded-2xl border border-dashed border-gray-200 flex flex-col items-center justify-center min-h-[500px]"
  >
    <div className="absolute inset-0 opacity-30">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: "radial-gradient(#FF6C6C 1px, transparent 1px)",
          backgroundSize: "20px 20px",
        }}
      />
    </div>
    <div className="relative flex flex-col items-center">
      <div className="mb-6 p-4 rounded-2xl bg-white shadow-sm">
        <MapPin className="w-10 h-10 text-[#FF6C6C]" />
      </div>
      <p className="text-gray-600 text-xl font-medium mb-3">
        No branches added yet
      </p>
      <p className="text-gray-400 mb-8">Add your first branch using the form</p>

      <motion.div
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        className="flex items-center gap-3 text-[#FF6C6C]/70 bg-[#FF6C6C]/5 px-4 py-3 rounded-xl"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 4V16M4 10H16"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className="text-sm font-medium">Add a new branch</span>
      </motion.div>
    </div>
  </motion.div>
);
export default EmptyState;